import { render, staticRenderFns } from "./ReplaceIcon.vue?vue&type=template&id=9f774c40&"
import script from "./ReplaceIcon.vue?vue&type=script&lang=js&"
export * from "./ReplaceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports